import React, { useEffect } from 'react';
import './ImgName.css';
import myImage from '../images/me.png';
import ReactTyped from "react-typed";

const ImgName = () => {
    useEffect(() => {

        const nameElement = document.querySelector('.name');

        function handleScroll() {
            const scrollY = window.scrollY;
            nameElement.style.transition = 'transform 0.0s ease-in-out';
            nameElement.style.transform = `translateX(${scrollY}px)`;
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="curved-rectangle">
            <div className='image-frame'>
                <img src={myImage} alt="This was supposed to be me" />
                <div className='name-div'>
                    <p className='name'>Rishabh Tripathi</p>
                </div>
                <div className='typography-div'>
                    <h1 className='typography'>
                        I'm{" "}
                        <ReactTyped className='suffix'
                            strings={["a Coder", "an Engineer", "a Connoisseur"]}
                            typeSpeed={90}
                            loop
                            backSpeed={15}
                            cursorChar="."
                            showCursor={true}
                        />
                    </h1>
                </div>

            </div>
        </div>
    );
};

export default ImgName;
